import { ReactNode } from "react";
import { Packet } from "../../../Interfaces/commonDtos";
import {
  IFailedOrderBulkPreviewResponse,
  IFailedOrderResendResult,
  IFailedOrderTableReport,
} from "../../../Interfaces/orderInterfaces";
import { ISearchParameters, Report } from "../../../Interfaces/TableInterfaces";
import TableTemplate from "../../TableTemplate/tableTemplate";
import FailedOrdersTableUI, { IFailedOrderResendPreview } from "./FailedOrdersTableUI";

interface IFailedOrdersTableProps<T> {
  getData: (
    searchParameters: T,
    offset: number | null,
    pageSize: number | null,
  ) => Promise<Report<IFailedOrderTableReport>>;
  previewResend: (id: number) => Promise<IFailedOrderResendPreview>;
  resendOrder?: (id: number, orderDto: any) => Promise<Packet<boolean>>;
  sendOrder?: (orderDto: any) => Promise<Packet<boolean>>;
  markResolved?: (id: number) => Promise<Packet<boolean>>;
  renderPreviewRows: (rows: any[]) => ReactNode;
  previewResendBulk: (
    ids: number[],
  ) => Promise<IFailedOrderBulkPreviewResponse<IFailedOrderResendPreview>>;
  resendBulk: (
    items: Array<{ id: number; orderDto: any }>,
  ) => Promise<IFailedOrderResendResult[]>;
  searchParams: T;
  onFetchComplete?: (page?: number) => void;
  refreshFlag?: boolean;
}

const FailedOrdersTable = <T extends ISearchParameters>({
  getData,
  previewResend,
  resendOrder,
  sendOrder,
  markResolved,
  renderPreviewRows,
  previewResendBulk,
  resendBulk,
  searchParams,
  onFetchComplete,
  refreshFlag,
}: IFailedOrdersTableProps<T>) => {
  return (
    <div className="order-table w-full">
      <TableTemplate<T, IFailedOrderTableReport>
        getDataTable={getData}
        TableUI={({ reports, onAction }) => (
          <FailedOrdersTableUI
            reports={reports}
            onAction={onAction}
            previewResend={previewResend}
            resendOrder={resendOrder}
            sendOrder={sendOrder}
            markResolved={markResolved}
            renderPreviewRows={renderPreviewRows}
            previewResendBulk={previewResendBulk}
            resendBulk={resendBulk}
            refreshFlag={refreshFlag}
          />
        )}
        searchParameters={searchParams}
        onFetchComplete={onFetchComplete}
      />
    </div>
  );
};

export default FailedOrdersTable;
